import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
	faBoxOpen,
	faCashRegister,
	faChartLine,
	faCheck,
	faClock,
	faCreditCard,
	faDesktop,
	faGlobe,
	faHeadset,
	faLanguage,
	faListCheck,
	faLocationDot,
	faMobileScreenButton,
	faMotorcycle,
	faRocketLaunch,
	faShieldHalved,
	faStore,
	faTabletScreenButton,
	faTruck,
	faTruckFast,
	faUser,
} from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "@/components/ui/Icon";

// FontAwesome Pro icon for each of the landing feature cards' glyph slots.
const ICONS: Record<string, IconDefinition> = {
	stores: faStore,
	bilingual: faLanguage,
	pos: faCashRegister,
	payments: faCreditCard,
	shipping: faTruckFast,
	analytics: faChartLine,
	isolation: faShieldHalved,
	domain: faGlobe,
	support: faHeadset,
	rocket: faRocketLaunch,
	parcel: faBoxOpen,
	truck: faTruck,
	clock: faClock,
	pin: faLocationDot,
	person: faUser,
	rules: faListCheck,
	check: faCheck,
	desktop: faDesktop,
	tablet: faTabletScreenButton,
	phone: faMobileScreenButton,
	motorcycle: faMotorcycle,
};

export type GlyphName = keyof typeof ICONS;
export const GLYPH_NAMES = Object.keys(ICONS);

interface GlyphProps {
	name: GlyphName;
	className?: string;
}

function Glyph(prop: GlyphProps) {
	const { name, className } = prop;
	const icon = ICONS[name] ?? ICONS.stores;
	return <Icon icon={icon} className={className} />;
}

export default Glyph;
